import styled from 'styled-components';
import { media } from '../mixins';

export { default as Navigation } from './Navigation';
export { Button } from './Button';
const defaultInputStyles = ({ theme }) => `
  &:placeholder {
    color: #ddd;
  }
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  display: block;
  border:none;
  border-bottom: 0.2em solid ${theme.palette.colorSecondaryFirst};
  background-color: ${theme.palette.colorPrimary};
  color: white;
  outline: none;
  vertical-align: bottom;
  font-size:1.1em;
`;
export const FormGroup = styled.div`
  width: 100%;
  vertical-align: bottom;
  margin: 0.6em 0;
  label {
    width: 100%;
    font-family: 'Space Mono', monospace;
    font-weight: bold;
    padding: 1.8em 0;
  }
`;
export const Select = styled.select`
  ${props => defaultInputStyles(props)};
  padding: 2px;
`;
export const TextArea = styled.textarea`
  ${props => defaultInputStyles(props)};
`;

export const Input = styled.input`
  ${props => defaultInputStyles(props)};
  padding: 3px;
`;
export const Form = styled.form`
  ${media.tablet`width: 100%;`};
  display: block;
`;
export const Wrapper = styled.div`
  ${media.tablet`padding:0.2em;`};
  padding: 1.3em 3em;
`;
export const MainWrapper = styled.div`
  padding: 3em;
  max-width: 800px;
  width: 100%;
  ${media.tablet`width:100vw;padding:0;margin:0`};
  margin: 0 auto;
`;
export const PageWrapper = styled.div`
  width: 100vw;
  display: flex;
  justify-content: space-around;
`;
export const Flex = styled.div`
  display: flex;
  ${({ breakpoint }) =>
    breakpoint && media[breakpoint] ? media[breakpoint]`display:block;` : ''};
  ${({ direction }) => (direction ? 'flex-direction: ' + direction + ';' : '')};
  ${({ justify }) => (justify ? 'justify-content:' + justify + ';' : '')};
  ${({ height }) => (height ? 'height:' + height + ';' : '')};
  ${({ width }) => (width ? 'width:' + width + ';' : '')};
`;
export const Footer = styled.div`
  display: flex;
  justify-content: center;
  ${({ height }) => (height ? 'height:' + height + ';' : '')};
  ${({ width }) => (width ? 'width:' + width + ';' : '')};
`;

export const Table = styled.table`
  width: 100%;
  border: 1px solid #ddd;
  border-collapse: collapse;
  thead {
    background-color: #282f36;
    border-bottom: 0.2em solid
      ${({ theme }) => theme.palette.colorSecondaryFirst};
    color: white;
    th {
      padding: 0.5em;
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #ddd;
      td {
        padding: 0.4em;
      }
      &:hover {
        background-color: #ddd;
      }
      a {
        text-decoration: none;
        display: block;
        width: 100%;
        color: black;
      }
      td:last {
        text-align: right;
      }
    }
  }
`;
export const Card = styled.div`
  padding: 1.4em;
  border: 1px solid grey;
`;
